import script from "./IssueBulkActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueBulkActions.vue?vue&type=script&lang=ts&setup=true"

import "./IssueBulkActions.vue?vue&type=style&index=0&id=b21c6e14&lang=scss&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b21c6e14"]])

export default __exports__